// @flow
import React, { Fragment, } from 'react';
import { FelaComponent, } from 'react-fela';
import dynamic from 'next/dynamic';
import { useMedia, Loading, } from '@haaretz/htz-components';

import type { Node, } from 'react';

import RowItem from '../RowItem/RowItem';

const MobileVolumeGraph = dynamic(() => import('../Graph/graphs/Volume/MobileVolume'), { ssr: false, loading: () => <Loading minHeight="120px" />, });
const DesktopVolumeGraph = dynamic(() => import('../Graph/graphs/Volume/Volume'), { ssr: false, loading: () => <Loading minHeight="104px" />, });
const MobileYieldGraph = dynamic(() => import('../Graph/graphs/Yield/MobileYield'), { ssr: false, loading: () => <Loading minHeight="119px" />, });
const DesktopYieldGraph = dynamic(() => import('../Graph/graphs/Yield/Yield'), { ssr: false, loading: () => <Loading minHeight="145px" />, });

type Props = {
  volume: number,
  dailyAvgVolume: number,
  weeklyYield: number,
  monthlyYield: number,
  quarterlyYield: number,
  yearlyYield: number,
  isForeign?: boolean,
};

AssetStaticGraph.defaultProps = {
  volume: 0,
  dailyAvgVolume: 0,
  weeklyYield: 0,
  monthlyYield: 0,
  quarterlyYield: 0,
  yearlyYield: 0,
  isForeign: false,
};

function AssetStaticGraph({
  volume,
  dailyAvgVolume,
  weeklyYield,
  monthlyYield,
  quarterlyYield,
  yearlyYield,
  isForeign,
}: Props): Node {
  const isMobile = useMedia({ query: { until: 's', }, });

  const mobileMiscStyles = {
    marginBottom: '2rem',
    paddingStart: '1rem',
    paddingEnd: '1rem',
  };

  const desktopMiscStyles = (additionalStyles = {}) => ({
    marginBottom: '2rem',
    paddingStart: '2rem',
    paddingEnd: '2rem',
    ...(additionalStyles || {}),
  });

  const volumeProps = {
    data: [
      { name: `מחזור (${isForeign ? 'מ׳ דולרים' : 'א׳ שח'})`, value: volume || 0, },
      { name: 'מחזור יומי ממוצע (שנה)', value: dailyAvgVolume || 0, },
    ],
    miscStyles: isMobile ? mobileMiscStyles : desktopMiscStyles(),
  };

  const yieldProps = {
    data: [
      { name: 'שבוע ', value: weeklyYield || 0, },
      { name: 'חודש', value: monthlyYield || 0, },
      { name: 'רבעון', value: quarterlyYield || 0, },
      { name: 'שנה', value: yearlyYield || 0, },
    ],
    miscStyles: isMobile ? mobileMiscStyles : desktopMiscStyles({ marginBottom: '2px', }),
  };

  return (
    <FelaComponent
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {({ className, theme, }) => (
        <div className={isMobile ? '' : className}>
          {
          isMobile
            ? (
              <Fragment>
                <RowItem title="מחזורים">
                  <MobileVolumeGraph
                    theme={theme}
                    {...volumeProps}
                  />
                </RowItem>
                <RowItem title="תשואות">
                  <MobileYieldGraph
                    theme={theme}
                    {...yieldProps}
                  />
                </RowItem>
              </Fragment>
            )
            : (
              <Fragment>
                <RowItem title="מחזורים">
                  <DesktopVolumeGraph
                    theme={theme}
                    {...volumeProps}
                  />
                </RowItem>
                <RowItem
                  title="תשואות"
                  miscStyles={{
                    // flexGrow: 1,
                    display: 'flex',
                    alignItems: 'flex-end',
                    ':not(:first-child)': { flexGrow: 1, },
                  }}
                >
                  <DesktopYieldGraph
                    theme={theme}
                    {...yieldProps}
                  />
                </RowItem>
              </Fragment>
            )
          }
        </div>
      )}
    </FelaComponent>
  );
}

export default AssetStaticGraph;
